import { useCallback, useRef, useState } from "react"

export function useDebouncedId(timeout = 1000) {
    const timer = useRef()
    const [id, setId] = useState(0)
    const [isPending, setIsPending] = useState(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const invalidate = useCallback(doInvalidate, [timeout])
    invalidate.id = id
    invalidate.isPending = isPending
    return invalidate

    function doInvalidate() {
        setIsPending(true)
        clearTimeout(timer.current)
        timer.current = setTimeout(() => {
            setIsPending(false)
            setId((currentId) => currentId + 1)
        }, timeout)
    }
}
